<template>
  <div class="animate__animated animate__fadeIn">
    <OptionsGenerateQR />
  </div>
</template>

<script>
import OptionsGenerateQR from "@/components/generate-qr/OptionsGenerateQR.vue";
export default {
  components: { OptionsGenerateQR },
};
</script>

<style></style>
